export default class FormatTemplate
{
	type;
	template;

	constructor(type: string, template: string)
	{
		this.type = type;
		this.template = template;
	}
}